const breadcrumbsHome = { name: 'Home', pathName: '/home', onlyAvailableOnVue2: true }

export default [
  {
    path: '/v3/dashboard-builder',
    name: 'DashboardBuilder',
    component: () => import('@/modules/dashboard-builder/views/DashboardBuilder.vue'),
    meta: {
      title: 'Dashboard Builder',
      breadcrumbs: [breadcrumbsHome, { name: 'Dashboard Builder', pathName: null }],
    },
  },
]
